import { color } from '../color/index.mjs';
import { colorRegex } from '../utils/color-regex.mjs';
import { floatRegex } from '../utils/float-regex.mjs';
import { sanitize } from '../utils/sanitize.mjs';

function test(v) {
  var _v$match, _v$match2;

  return isNaN(v) && typeof v === "string" && (((_v$match = v.match(floatRegex)) === null || _v$match === void 0 ? void 0 : _v$match.length) || 0) + (((_v$match2 = v.match(colorRegex)) === null || _v$match2 === void 0 ? void 0 : _v$match2.length) || 0) > 0;
}

var NUMBER_TOKEN = "number";
var COLOR_TOKEN = "color";
var VAR_TOKEN = "var";
var VAR_FUNCTION_TOKEN = "var(";
var SPLIT_TOKEN = "${}"; // this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`

var complexRegex = /var[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\x2D\x2D(?:[\x2D0-9A-Z_a-z\u017F\u212A]+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*|[\x2D0-9A-Z_a-z\u017F\u212A]+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*,(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:(?![\t-\r \(\)\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])[\s\S])|[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\((?:(?:(?![\(\)])[\s\S])|\((?:(?![\(\)])[\s\S])*\))*\))+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)\)|#[0-9a-f]{3,8}|(?:rgb|h[s\u017F]l)a?\((?:\x2D?[\.0-9]+%?[\t-\r ,\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+){2}\x2D?[\.0-9]+%?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:[,\/][\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)?(?:\b[0-9]+(?:\.[0-9]+)?|\.[0-9]+)?%?\)|\x2D?(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)/gi;

function analyseComplexValue(value) {
  var originalValue = value.toString();
  var values = [];
  var indexes = {
    color: [],
    number: [],
    var: []
  };
  var types = [];
  var i = 0;
  var tokenised = originalValue.replace(complexRegex, function (parsedValue) {
    if (color.test(parsedValue)) {
      indexes.color.push(i);
      types.push(COLOR_TOKEN);
      values.push(color.parse(parsedValue));
    } else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
      indexes.var.push(i);
      types.push(VAR_TOKEN);
      values.push(parsedValue);
    } else {
      indexes.number.push(i);
      types.push(NUMBER_TOKEN);
      values.push(parseFloat(parsedValue));
    }

    ++i;
    return SPLIT_TOKEN;
  });
  var split = tokenised.split(SPLIT_TOKEN);
  return {
    values: values,
    split: split,
    indexes: indexes,
    types: types
  };
}

function parseComplexValue(v) {
  return analyseComplexValue(v).values;
}

function createTransformer(source) {
  var _analyseComplexValue = analyseComplexValue(source),
      split = _analyseComplexValue.split,
      types = _analyseComplexValue.types;

  var numSections = split.length;
  return function (v) {
    var output = "";

    for (var i = 0; i < numSections; i++) {
      output += split[i];

      if (v[i] !== undefined) {
        var type = types[i];

        if (type === NUMBER_TOKEN) {
          output += sanitize(v[i]);
        } else if (type === COLOR_TOKEN) {
          output += color.transform(v[i]);
        } else {
          output += v[i];
        }
      }
    }

    return output;
  };
}

var convertNumbersToZero = function convertNumbersToZero(v) {
  return typeof v === "number" ? 0 : color.test(v) ? color.getAnimatableNone(v) : v;
};

function getAnimatableNone(v) {
  var parsed = parseComplexValue(v);
  var transformer = createTransformer(v);
  return transformer(parsed.map(convertNumbersToZero));
}

var complex = {
  test: test,
  parse: parseComplexValue,
  createTransformer: createTransformer,
  getAnimatableNone: getAnimatableNone
};
export { analyseComplexValue, complex };